'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:timeTable');
}

var _invoke = require('../invoke');

/**
 * 展示列车时刻表
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof train
 * @static
 * @name timeTable
 * @param {Object} stations
 * @return {Undefined}
 * @example
 *  hbnb.train.timeTable([{
 *      type: 'inside/outside/from/to',
 *      value: [
 *          'station_no',
 *          'station_name',
 *          'arrive_time',
 *          'start_time'
 *          'stopover_time'
 *      ]
 *  }]);
 */
module.exports = function(stations) {
    if (process.env.NODE_ENV !== 'production') {
        debug('stations is %j', stations);
    }

    _invoke('train', 'time_table', {
        title: '列车时刻表',
        header: ['', '车站', '到达', '发车', '停留'],
        rows: stations
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/time-table.js
// module id = 639
// module chunks = 0